(() => {
  if (customElements.get('jj-bottle-purchase')) return;
  class BottlePurchase extends HTMLElement {
    async connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      await customElements.whenDefined('product-form');
      this.querySelectorAll('[data-volume-option]').forEach(el => { el.hidden = false; });
      const popular = this.querySelector('[name="bottle_pack"][value="2"]');
      if (popular) popular.checked = true;
      this.addEventListener('change', () => this.update());
      this.update();
    }
    update() {
      const pack = this.querySelector('[name="bottle_pack"]:checked');
      const count = Number(pack.value);
      const colors = [];
      let available = true;
      this.querySelectorAll('[data-bottle-row]').forEach(row => {
        const index = Number(row.dataset.bottleRow);
        const selected = row.querySelector('input:checked');
        row.hidden = index > count;
        row.disabled = index > count;
        if (index <= count) {
          available = available && !!selected && !selected.disabled;
          colors.push(selected?.dataset.title || '');
        }
        row.querySelector('[data-bottle-color-label]').textContent = selected?.dataset.title || '';
        if (index === 1) this.querySelector('[data-bottle-id]').value = selected?.value || '';
        else {
          const extra = this.querySelector(`[data-extra-bottle="${index}"]`);
          extra.checked = index <= count;
          extra.value = selected?.value || '';
        }
      });
      const price = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:this.dataset.currency,minimumFractionDigits:Number(pack.dataset.price)%100 ? 2 : 0,maximumFractionDigits:2}).format(Number(pack.dataset.price)/100);
      const button = this.querySelector('[type="submit"]');
      button.disabled = !available;
      this.querySelector('[data-add-label]').textContent = available ? `Add ${count === 1 ? 'bottle' : count + ' bottles'} · ${price}` : 'Sold out';
      button.setAttribute('aria-label', available ? `Add ${count} bottle${count > 1 ? 's' : ''}: ${colors.join(', ')} for ${price}` : 'Sold out');
      this.querySelector('[data-pack-note]').textContent = count > 1 ? `${price} total · Savings applied automatically in cart.` : 'One bottle. One-time purchase.';
    }
  }
  customElements.define('jj-bottle-purchase', BottlePurchase);
})();
